/**
 * B2B Cart Attribute Guard
 * Garantiza que el carrito siempre tenga el atributo `is_b2b` establecido,
 * independientemente de cómo el usuario llegue al checkout.
 */
(function () {
  'use strict';

  const IS_B2B = window.__upngCustomerIsB2b === true;
  const ATTRIBUTE_NAME = 'attributes[is_b2b]';
  const CHECKOUT_URLS = ['/checkout', '/checkouts'];

  function hasInvalidCartLines() {
    return Boolean(document.querySelector('#cart-items [data-b2b-invalid="true"]'));
  }

  function updateInvalidCartState() {
    const invalid = hasInvalidCartLines();
    document.querySelectorAll('[name="checkout"], .upng-cart-checkout-button').forEach(function (button) {
      button.disabled = invalid;
      button.setAttribute('aria-disabled', invalid ? 'true' : 'false');
    });
    document.querySelectorAll('.dynamic-cart-btns, [data-shopify="payment-button"]').forEach(function (container) {
      container.hidden = invalid;
    });
    document.querySelectorAll('.b2b-cart-subtotal-sin-iva').forEach(function (summary) {
      summary.hidden = invalid;
    });
  }

  /**
   * Establece el atributo is_b2b en el carrito vía Shopify Cart API.
   * @returns {Promise<void>}
   */
  function setB2bAttribute() {
    const formData = new FormData();
    formData.append(ATTRIBUTE_NAME, IS_B2B ? 'true' : 'false');

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
    }).catch(function (err) {
      console.warn('[B2B] No se pudo sincronizar atributo is_b2b:', err);
    });
  }

  /**
   * Verifica si un elemento o URL apunta al checkout.
   */
  function isCheckoutUrl(url) {
    if (!url) return false;
    const lower = url.toLowerCase();
    return CHECKOUT_URLS.some(function (prefix) {
      return lower.indexOf(prefix) === 0;
    });
  }

  /**
   * Maneja la navegación a checkout: primero sincroniza el atributo,
   * luego permite continuar.
   */
  function guardCheckout(originalEvent, continueCallback) {
    originalEvent.preventDefault();
    originalEvent.stopImmediatePropagation ? originalEvent.stopImmediatePropagation() : originalEvent.stopPropagation();

    setB2bAttribute().finally(function () {
      continueCallback();
    });
  }

  /**
   * Inicializa el guardia de checkout.
   */
  function init() {
    // 1. Sincronizar al cargar la página
    setB2bAttribute();
    updateInvalidCartState();
    const cartObserverTarget = document.body || document.documentElement;
    if (cartObserverTarget) new MutationObserver(updateInvalidCartState).observe(cartObserverTarget, { childList: true, subtree: true });

    // 2. Interceptar clicks en botones/links que vayan a checkout
    document.addEventListener('click', function (event) {
      const target = event.target.closest ? event.target.closest('a, button, [type="submit"]') : null;
      if (!target) return;

      // Botón con name="checkout"
      if (target.name === 'checkout' || target.getAttribute('name') === 'checkout') {
        if (hasInvalidCartLines()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          updateInvalidCartState();
          return;
        }
        guardCheckout(event, function () {
          if (target.form) {
            let hidden = target.form.querySelector('input[name="attributes[is_b2b]"]');
            if (!hidden) {
              hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'attributes[is_b2b]';
              target.form.appendChild(hidden);
            }
            hidden.value = IS_B2B ? 'true' : 'false';
            if (typeof target.form.requestSubmit === 'function') {
              target.form.requestSubmit(target);
            } else {
              target.form.submit();
            }
          } else {
            // Si no tiene formulario, redirigir manualmente
            window.location.href = '/checkout';
          }
        });
        return;
      }

      // Links que apunten a checkout
      if (target.tagName === 'A') {
        const href = target.getAttribute('href');
        if (isCheckoutUrl(href)) {
          guardCheckout(event, function () {
            window.location.href = href;
          });
        }
      }
    }, true);

    // 3. Interceptar submits de formularios que vayan al carrito o checkout
    document.addEventListener('submit', function (event) {
      const form = event.target;
      const action = form.getAttribute('action') || '';

      if (isCheckoutUrl(action) || form.querySelector('[name="checkout"]')) {
        if (hasInvalidCartLines()) {
          event.preventDefault();
          updateInvalidCartState();
          return;
        }
        // Asegurar que el input hidden existe
        let hidden = form.querySelector('input[name="attributes[is_b2b]"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'attributes[is_b2b]';
          form.appendChild(hidden);
        }
        hidden.value = IS_B2B ? 'true' : 'false';
        // Dejar que el submit continúe normalmente; el input ya está presente
      }
    }, true);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
})();
